module.exports = __webpack_public_path__ + "img/fi-rr-interrogation.e454bbf6.svg";